import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import TextField from "app/components/form/TextField";
import { GroupMapper } from "features/planner/planner.mappers";
import DatePickerField from "app/components/form/DatePickerField";
import { getGroupFromState } from "features/planner/planner.selectors";
import { CREATE_CARD_MOVE_FORM } from "features/planner/planner.constants";
import HoursDropDown from "features/planner/components/CreateCardMove/HoursDropDown";
import MinutesDropDown from "features/planner/components/CreateCardMove/MinutesDropDown";

const ReturnOnshoreForm = ({ handleSubmit, sourceGroup }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid container item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Field
                component={DatePickerField}
                name={CREATE_CARD_MOVE_FORM.DEPARTURE_DATE}
                DatePickerProps={{
                  margin: "normal",
                  label: `Departure from ${sourceGroup.get("name")}`,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <HoursDropDown name={CREATE_CARD_MOVE_FORM.DEPARTURE_HOUR} />
            </Grid>
            <Grid item xs={3}>
              <MinutesDropDown name={CREATE_CARD_MOVE_FORM.DEPARTURE_MINUTE} />
            </Grid>
            <Grid item xs={12}>
              <Field
                rows={4}
                multiline
                label="Comment"
                margin="dense"
                component={TextField}
                name={CREATE_CARD_MOVE_FORM.DEPLOYMENT_COMMENT}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

ReturnOnshoreForm.defaultProps = {
  sourceGroup: GroupMapper.initial(),
};

export default compose(
  connect((state, { formValueSelector }) => {
    const sourceGroupId = formValueSelector(
      state,
      CREATE_CARD_MOVE_FORM.SOURCE_GROUP_ID,
    );

    return {
      sourceGroup: sourceGroupId
        ? getGroupFromState(state, sourceGroupId)
        : undefined,
    };
  }),
  React.memo,
)(ReturnOnshoreForm);
